import {FaClock} from "react-icons/fa";

const ImagePreparationProgress = ({loaded = 0, total = 0, className = ""}) => {
  const safeTotal = Number.isFinite(total) ? Math.max(0, total) : 0;
  const safeLoaded = Number.isFinite(loaded) ? Math.min(safeTotal, Math.max(0, loaded)) : 0;

  if (safeTotal === 0 || safeLoaded >= safeTotal) return null;

  const progress = (safeLoaded / safeTotal) * 100;

  return (
    <div className={["flex justify-end print:hidden", className].join(" ")}>
      <div
        className="relative flex min-h-[40px] w-fit max-w-[min(390px,100%)] min-w-0 items-center overflow-hidden rounded-[3px] bg-[#ffa500]/40 px-2.5 py-2 text-[12px] font-bold text-white shadow"
        role="progressbar"
        aria-label="Preparando imagens para impressão"
        aria-valuemin={0}
        aria-valuemax={safeTotal}
        aria-valuenow={safeLoaded}
      >
        <div
          className="absolute inset-y-0 left-0 bg-[#ffa500] transition-[width] duration-300 ease-out"
          style={{width: `${progress}%`}}
          aria-hidden="true"
        />
        <span className="relative z-10 flex w-full items-center justify-center gap-2 text-center">
          <FaClock className="shrink-0"/>
          <span>Preparando imagens para impressão: {safeLoaded}/{safeTotal}</span>
        </span>
      </div>
    </div>
  );
};

export default ImagePreparationProgress;